import { createFileRoute } from '@tanstack/react-router';
import ApplicationCreatePage from '@/components/DeveloperApplications/ApplicationCreatePage';

export const Route = createFileRoute('/developers/applications/create')({
  component: ApplicationCreatePage,
});
